module.exports = __webpack_public_path__ + "static/media/Last4.1ac8a75a.jpg";